<template>
  <div id="SectionEcovadisTrackRecord">
    <UIContainer class="SectionEcovadisTrackRecord__container">
      <template #left>
        <SectionTitle titleSize="sm">
          <template #heading> Our Track Record </template>
          <template #title> Your success is our guarantee </template>

          <template #description> We stand behind our results </template>
        </SectionTitle>

        <div class="SectionEcovadisTrackRecord__badges">
          <div class="SectionEcovadisTrackRecord__badge">
            <div class="SectionEcovadisTrackRecord__badge-high-satisfaction">
              98%
            </div>
            <div class="SectionEcovadisTrackRecord__badge-description">
              of clients improve their EcoVadis rating by 2+ levels
            </div>
          </div>
          <div class="SectionEcovadisTrackRecord__badge">
            <div class="SectionEcovadisTrackRecord__badge-high-satisfaction">
              500+
            </div>
            <div class="SectionEcovadisTrackRecord__badge-description">
              successful EcoVadis assessments completed
            </div>
          </div>
          <div class="SectionEcovadisTrackRecord__badge">
            <img
              class="SectionEcovadisTrackRecord__badge-img"
              src="./assets/ecovadisTrackRecord/approved.avif"
              alt="EcoVadis approved calculator"
            />
            <div class="SectionEcovadisTrackRecord__badge-description">
              Expert team certified by EcoVadis
            </div>
          </div>
          <div class="SectionEcovadisTrackRecord__badge">
            <div class="SectionEcovadisTrackRecord__badge-high-satisfaction">
              4.9/5
              <StarRating :rating="4.9" />
            </div>
            <div class="SectionEcovadisTrackRecord__badge-description">
              Overall rating based on 100+ reviews
            </div>
          </div>
        </div>
      </template>

      <template #right>
        <div
          class="SectionEcovadisTrackRecord__image"
          role="img"
          aria-label="EcoVadis track record"
        />
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import StarRating from '@/views/components/ui/rating/UIStarRating.vue'
</script>

<style lang="scss" scoped>
#SectionEcovadisTrackRecord {
  position: relative;
  background-color: $color-white;

  // .SectionEcovadisTrackRecord__container { }

  :deep(.UIContainer__left) {
    @include md {
      padding-right: 3rem;
    }
  }

  .SectionEcovadisTrackRecord__image {
    display: none;
    width: 100%;
    height: 100%;
    background-image: url('./assets/ecovadisTrackRecord/bg.avif');
    background-size: cover; // fill width and height; crop overflow
    background-position: top center; // show from top
    background-repeat: no-repeat;

    @include md {
      display: block;
    }
  }

  .SectionEcovadisTrackRecord__content {
    padding: 1rem 0;
    @include md {
      margin-left: 6rem;
    }
  }

  .SectionEcovadisTrackRecord__badges {
    margin-top: 3rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;

    @include md {
      gap: 1.25rem;
    }
  }

  .SectionEcovadisTrackRecord__badge {
    background: $color-ui-gray-cool-50;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include md {
      padding: 1.25rem;
    }

    .SectionEcovadisTrackRecord__badge-description {
      @include font-size-16px();
      font-weight: 400;
      color: $color-ui-gray-cool-600;
      margin-top: 0.5rem;
    }

    .SectionEcovadisTrackRecord__badge-high-satisfaction {
      font-size: 3.75rem;
      font-weight: 600;
      color: $color-ui-brand-700;
      display: flex;
      flex-direction: column;
    }

    .SectionEcovadisTrackRecord__badge-worldwide {
      --size: 4.5rem;
      align-self: self-start;
      --color: #{$color-ui-brand-700};
    }

    .SectionEcovadisTrackRecord__badge-img {
      height: 88px;
      width: auto;
      align-self: self-start;
    }
  }

  .SectionEcovadisTrackRecord__square {
    width: 100%;
    max-width: 96px;
    aspect-ratio: 1 / 1;
    border-radius: 0.5rem;
    background: $color-ui-gray-cool-200;
    border: 2px dashed $color-ui-gray-cool-400;
  }
}
</style>
